<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <h2>Welcome Text</h2>
        <p>The welcome text below appears on the landing page of the application prior to the user logging in.</p>
      </b-col>
    </b-row>

    <b-row>
        <b-col>
            <quill-editor
                ref="myQuillEditor"
                v-model="setting.value"
                :options="editorOptions"
            />
        </b-col>
    </b-row>

    <b-row>
      <b-col>
         <b-button type="button" variant="primary" @click="saveSetting">Submit</b-button>
      </b-col>
    </b-row>

  </b-container>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import axios from "axios"
import { quillEditor } from 'vue-quill-editor'


export default {
  data: () => ({
    setting: { },
    editorOptions: {
        theme: 'snow',
        boundary: document.body,
        modules: {
        toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ 'header': 1 }, { 'header': 2 }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'script': 'sub' }, { 'script': 'super' }],
            [{ 'indent': '-1' }, { 'indent': '+1' }],
            [{ 'direction': 'rtl' }],
            [{ 'size': ['small', false, 'large', 'huge'] }],
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'font': [] }],
            [{ 'align': [] }],
            ['clean'],
            ['link', 'image', 'video']
        ]
        },
        placeholder: 'Insert text here ...',
        readOnly: false
    }
  }),
  components: {
    quillEditor
  },
  created() {
    this.loadSetting()
  },
  methods: {
    loadSetting() {
      axios.post(`${process.env.VUE_APP_API_BASE_URL}/admin/setting/query`, {
          key: 'welcome.text'
      })
          .then(response => { this.setting = response.data })
    },
    saveSetting() {
      axios.post(`${process.env.VUE_APP_API_BASE_URL}/admin/setting`, this.setting)
          .then(response => { this.setting = response.data })
    }
  }
}
</script>

<style>

</style>
